/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import { motion } from 'framer-motion'
import React, { useState, useEffect } from 'react'
import OfferToolTip from '../../Components/OfferToolTip'
import IndividualDiscountTooltip from './IndividualDiscountTootTip'
import Progressbar from './ProgressBar'

function IndividualCriteriaSummary({ prodItem,
    setsearchValue,
    specialCartList,
    setshowProducts,
    showNotMaching,
    criteriaObject,
    i,
    GetCartCount,
    setselectedCriteria,
    OrderValue,
    handleDiscount,
    ViewOffer,
    updateAmount,
    setupdateAmount,
    GetOfferData,
    offerData,criteriaMainObject,subsequentOrder,
    specialRecurring }) {
    const { items } = ViewOffer
    const criteria = criteriaObject[i]
    const [hover, sethover] = useState('')
    useEffect(() => {
    }, [criteriaObject, specialCartList])

    return (
        <div className={`lg:min-w-[25%] w-full bg-[#E9EDF4] border-2 border-[#E9EDF4] h-auto rounded-lg p-6 lg:mt-0 mt-5 mb-3.5`}>
            <p className="text-[#090406] text-xs font-semibold">Offer Criteria {i + 1}</p>
            <div className="relative">
                <div className=" mt-2 mb-4">
                    <div className="flex justify-center items-center">
                        <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                            {criteria?.OFFER_PARAMETER === "quantity" ?
                                <Progressbar
                                    max={Number(prodItem[i].MAX_QUANTITY) || 0}
                                    min={Number(prodItem[i].MIN_QUANTITY) || 0}
                                    chnaging={criteria?.total}
                                    GetOfferData={GetOfferData}
                                    offerData={offerData}
                                    criteriaObject={criteriaObject}
                                    OrderValue={specialRecurring ? criteria?.cumulative_quantity : criteria?.quantity}
                                    updateAmount={updateAmount}
                                    setupdateAmount={setupdateAmount}
                                    qunatity={true}
                                    i={i}
                                    ViewOffer={ViewOffer}
                                    specialRecurring={specialRecurring}
                                    currentItems={criteriaMainObject?.total_current_quantity}
                                    criteriaMainObject={criteriaMainObject}
                                    subsequentOrder={subsequentOrder} /> :
                                <Progressbar
                                    max={Number(prodItem[i].MAX_VALUE) || 0}
                                    min={Number(prodItem[i].MIN_VALUE) || 0}
                                    chnaging={OrderValue}
                                    GetOfferData={GetOfferData}
                                    offerData={offerData}
                                    criteriaObject={criteriaObject}
                                    OrderValue={(specialRecurring ) ? criteria?.cumulative_value : criteria?.total}
                                    currentItems={criteriaMainObject?.total_current_value}
                                    updateAmount={updateAmount}
                                    setupdateAmount={setupdateAmount}
                                    i={i} 
                                    ViewOffer={ViewOffer}
                                    specialRecurring={specialRecurring}
                                    criteriaMainObject={criteriaMainObject}
                                    subsequentOrder={subsequentOrder}/>}
                        </div>
                    </div>
                </div>

                {/* <div>
                            <div className="flex justify-between mb-1">
                                <span className="text-base font-medium text-blue-700 dark:text-white">Flowbite</span>
                                <span className="text-sm font-medium text-blue-700 dark:text-white">45%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                <div className="bg-blue-600 h-2.5 rounded-full" style="width: 45%"></div>
                            </div>
                        </div> */}
                {criteria?.OFFER_PARAMETER && <div className="pb-0 flex justify-between">
                    <p className="text-xs font-semibold text-[#000000]">{criteria?.OFFER_PARAMETER === 'quantity' ? <>
                        {Number(criteria?.MIN_QUANTITY)}</> : <>{Number(criteria?.MIN_VALUE).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) || 0}</>}</p>
                    <p className="text-xs font-semibold text-[#000000]">{criteria?.OFFER_PARAMETER === 'quantity' ? <>
                        {Number(criteria?.MAX_QUANTITY)}</> : <>{Number(criteria?.MAX_VALUE).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) || 0}</>}</p>
                </div>}
            </div>
            <>{criteria?.OFFER_PARAMETER === "quantity" && (specialRecurring ? (criteria?.cumulative_quantity > criteria?.MAX_QUANTITY) : (criteria?.quantity > criteria?.MAX_QUANTITY)) && criteria?.satisfied_criteria &&
                <motion.p
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.3 }}
                    key={criteria?.quantity}
                    className='mt-2 font-normal text-[green] ml-3'
                    style={{ padding: '1px', fontStyle: 'italic' }}>
                    Offer criteria matching at <span style={{ color: 'red' }}>Criteria{Number(criteria?.satisfied_criteria) + 1}</span>
                </motion.p>}</>
            <>{criteria?.OFFER_PARAMETER !== "quantity" && (specialRecurring ? (criteria?.cumulative_value > criteria?.MAX_VALUE) : (criteria?.total > criteria?.MAX_VALUE)) && criteria?.satisfied_criteria &&
                <motion.p
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.3 }}
                    key={criteria?.quantity}
                    className='mt-2 font-normal text-[green] ml-3'
                    style={{ border: '2px dotted red', padding: '4px' }}>
                    Offer criteria matching at <span style={{ color: 'red' }}>Criteria{Number(criteria?.satisfied_criteria) + 1}</span>
                </motion.p>}</>
            <p className="pt-4 font-semibold text-[#090406] text-xs">Quantity</p>
            <div className="flex justify-between items-center pt-2">
                <p className="font-normal text-[#555259] text-xs5">Line Items selected</p>
                <p className="font-normal text-base text-[#555259]">{criteria?.items}</p>
            </div>
            <div className="flex justify-between items-center mt-2">
                <p className="font-normal text-[#555259] text-xs5">Total Order Quantity</p>
                <p className="font-normal text-base text-[#555259]">{criteria?.quantity}</p>
            </div>
            <p className="mt-1 font-semibold text-[#090406] text-xs">Summary</p>
            <div className="flex justify-between items-center pt-2">
                <p className="text-xs5 font-normal text-[#555259]">Order value</p>
                <p className="font-normal text-base text-[#555259]">{criteria?.total && Number(criteria?.total).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                })}</p>
            </div>
            <div className="flex justify-between items-center mt-2">
                <div className="flex items-center">
                    <p className="text-xs5 font-normal text-[#555259]">Discount</p>
                    <span className="ml-1" onMouseEnter={() => {
                        setTimeout(() => {
                            sethover('active')
                        }, 1000);
                    }} onMouseLeave={() => {
                        setTimeout(() => {
                            sethover('')
                        }, 2000);
                    }} onClick={() => sethover('active')}>
                        <button
                            data-tooltip-target="tooltip-discountPrice1" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                        </button>
                        {showNotMaching === '' && hover !== '' && (
                            <IndividualDiscountTooltip hover={hover !== ''} prod={criteria} i={i} />
                        )}
                    </span>
                </div>
                <p className="font-normal text-base text-[#555259]">{showNotMaching === '' ? parseFloat(criteria?.discount || 0).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                }) : ''}</p>
            </div>
            <div className="flex justify-between items-center mt-2">
                <p className="text-xs5 font-bold text-[#555259]">Net Amount</p>
                <p className="font-bold text-base text-[#555259]">{showNotMaching === '' ? Number(criteria?.total - criteria?.discount || 0).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                }) : ''}</p>
            </div>
            <button
                disabled={i + 1 >= items.product_criterion.length}
                onClick={() => {
                    setselectedCriteria(i + 1);
                    setshowProducts(false);
                    setsearchValue('')
                }}
                type="button" className={`w-full ${i + 1 >= items.product_criterion.length ? 'bg-[#A5A5A5]' : 'bg-[#555259] cursor-pointer'} rounded-[8px] text-[#FFFFFF] text-sm font-semibold py-3 mt-2`}>
                Next Criteria
            </button>
        </div>
    )
}

export default IndividualCriteriaSummary